import { Component, OnInit, Input } from '@angular/core';
import { MarkerLabel } from '@agm/core';
import { HttpService, CoreService } from '../services';
import { MapModel } from '../models/map/map.model';
import { eAppContext } from '../models/global/class.global';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})

export class MapComponent implements OnInit {

  constructor(
    private http: HttpService,
    protected indParam: CoreService,
  ) { }

  customLabel: MarkerLabel = {
    color: 'transparent',
    fontFamily: 'Arial',
    fontSize: 'small',
    fontWeight: 'bold',
    text: ''
  };
  public loadedPage: boolean = false;
  public HideControls: boolean = false;
  public showMarker: boolean = true;

  @Input('latitude') latitude: number;
  @Input('longitude') longitude: number;
  @Input('adresse') adresse: string;

  @Input('label')
  set label(value: string) {
    if (value) {
      this.customLabel.text = `${value}`;
    }
  }

  ngOnInit(): void {
    if (
      (
        (!this.latitude && this.latitude !== 0)
        || (!this.longitude && this.longitude !== 0)
      )
      && this.adresse
    ) {
      const model: MapModel = new MapModel();
      model.address = this.adresse;
      model.Mode = 'RETRIEVE_ADDRESS_COORDINATES';
      let apiUrl: string = '';
      switch (this.indParam.Context) {
        case eAppContext.QUEOVAL:
          apiUrl = this.indParam.AppParams.apiUrl;
          break;
        default:
          //apiUrl = this.indParam.ConfigFile.apiUrl;
          apiUrl = this.indParam.AppParams.apiUrl;
          break;
      }
      this.http.postHttp<MapModel>(`${apiUrl}api/map/`, model).subscribe((result: MapModel) => {
        if (!result.HasError) {
          this.latitude = result.lat;
          this.longitude = result.lng;
        }
        this.loadedPage = true;
      });
    }
    else {
      this.loadedPage = true;
    }

  }

  showDetail(): void {
    if (this.customLabel.text) {
      this.showMarker = false;
      setTimeout(() => {
        if (this.customLabel.color === 'transparent') {
          this.customLabel.color = 'black';
        }
        else {
          this.customLabel.color = 'transparent';
        }
        this.showMarker = true;
      }, 0);
    }
  }
}
